import React from "react";
import { motion } from "framer-motion";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faReact } from "@fortawesome/free-brands-svg-icons";
import Selfie from "../../assets/images/selfie_0.jpg";
import Footer from "../common/footer";
import "./profileTab.css";
// import DarkModeToggleButton from "./DarkModeToggleButton";

const ProfileTab = () => {
  return (
    <>
      <article
        id="profile-tab-container"
        className="w-full lg:flex-shrink-0 lg:w-[320px]"
      >
        <div
          id="profile-tab"
          className="px-5 py-5 text-center glass  lg:h-full lg:flex lg:flex-col lg:justify-center lg:items-center lg:fixed "
        >
          {/* <div className="absolute top-8 left-8">
            <DarkModeToggleButton />
          </div> */}
          <div
            id="selfie-wrapper"
            className="rounded-full my-6 mx-auto flex justify-center items-center h-[160px] w-[160px] aspect-square bg-[#e5e5e5] morphism-inner transition-colors duration-500 "
          >
            <img
              id="selfie"
              src={Selfie}
              className="rounded-full saturate-[.85] h-full w-full p-[6px] object-cover object-top"
              alt="My selfie"
              width={160}
              height={160}
              priority
            />
          </div>
          <aside className="text-sm">
            {/* <h3 className="text-lg text-[#7562E0] transition-colors duration-200">
              Tung Yuen Lok (Johnny) <br />
            </h3> */}
            <h4 className="leading-6 transition-colors duration-100">
              MSc in Finance @ CUHK
              <br />
            </h4>
            <h4 className="leading-6 transition-colors duration-100">
              BSc in Mathematics
              <br />
            </h4>
            <p
              id="intro"
              className="italic text-[.8rem] lg:text-[.7rem] leading-normal my-4 max-w-[280px] mx-auto text-neutral-500 transition-colors duration-200"
            >
              Passionate about Quant Trading
            </p>
          </aside>
          <motion.button
            whileHover={{
              border: "2px rgba(238, 238, 238, 0.5) solid",
              transition: { duration: 0.1 },
            }}
            initial={{
              border: "1px solid rgba(238, 238, 238, 0.3)",
            }}
            // bg-gradient-to-tr from-neutral-300 to-neutral-200 dark:bg-neutral-600/20 dark:from-neutral-600/20 dark:to-neutral-600/30 border-[1px] dark:border-black/30
            whileTap={{ scale: 0.99 }}
            className="rounded-md px-4 py-0 my-8 mx-auto h-14 
            morphism-outer from-neutral-700/50 to-neutral-700/30 transition-colors duration-200
            "
          >
            <a
              // href="/assets/CV.pdf"
              // download="CV.pdf"
              // href="https://docs.google.com/document/d/1s4XE0lL6XPQ41iwvLMm38Qj1D97EVzxxl5aCxwwFiK8/edit"
              className="no-underline tracking-[2.5px] uppercase font-bold text-xs py-5 px-0 transition-colors duration-200"
            >
              VIEW MY CV
            </a>
          </motion.button>
        </div>
        <Footer />
      </article>
    </>
  );
};

export default ProfileTab;
